export const ROUTES = {
  start: '/',
  matchcard: ':eventSlug',
  roster: '/roster',
  wrestler: ':wrestlerSlug',
  aboutUs: '/about-us',
  // events: '/events',
  training: '/training',
  supporter: '/supporter',
  contact: '/kontakt',
  impressum: '/impressum',
  datenschutz: '/datenschutz',
}
